import { useContext } from 'react';
import { FilterDataContext } from '../contexts/filterDataContext';

const useModalCheckBoxEngaged = () => {
  const { allStatesCheckEngaged, allStatesAvailableCheckEngaged,setAllStatesCheckEngaged, setAllStatesAvailableCheckEngaged } =
    useContext(FilterDataContext);

  const getValue = (getCheckBoxValueContractedPlan: any) => {
    const statesCheck = { ...allStatesCheckEngaged };

    getCheckBoxValueContractedPlan.map((value: string) => ({ [value]: true }));

    Object.keys(statesCheck).forEach((key) => {
      statesCheck[key] = getCheckBoxValueContractedPlan.includes(key);
    });

    setAllStatesCheckEngaged(statesCheck);
  };
  const getValueAvailable = (getCheckBoxValueAvailablePlan: any) => {
    const statesAvailableCheck = { ...allStatesAvailableCheckEngaged };

    getCheckBoxValueAvailablePlan.map((value: string) => ({ [value]: true }));

    Object.keys(statesAvailableCheck).forEach((key) => {
      statesAvailableCheck[key] = getCheckBoxValueAvailablePlan.includes(key);
    });

    setAllStatesAvailableCheckEngaged(statesAvailableCheck);
  };
  return { getValue, getValueAvailable, allStatesCheckEngaged };
};
export default useModalCheckBoxEngaged;
